import { render, staticRenderFns } from "./DropdownItemCombo.vue?vue&type=template&id=b3e5f96a&scoped=true"
import script from "./DropdownItemCombo.vue?vue&type=script&lang=js"
export * from "./DropdownItemCombo.vue?vue&type=script&lang=js"
import style0 from "./DropdownItemCombo.vue?vue&type=style&index=0&id=b3e5f96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e5f96a",
  null
  
)

export default component.exports